import { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from './AuthContext';
import { fetchWrapper, SERVER } from '../utils/helpers';

const ReportContext = createContext();

export function ReportProvider({ children }) {
	const [isDataLoaded, setIsDataLoaded] = useState("INITIALIZE");

	const { user, password, encodedAuth } = useAuth();

	useEffect(() => {
		if (user && isDataLoaded === "INITIALIZE") {
			setIsDataLoaded("PENDING");
			// loadReports();
		}
	}, [user]);

	function loadReports() {
		const fetchReports = async () => {
			try {
				await fetchWrapper(`${SERVER}/reports`, user, password, encodedAuth);
				setIsDataLoaded("SUCCESS");
			} catch (err) {
				setIsDataLoaded("FAILED");
			}
		};
		fetchReports();
	}

	return (
		<ReportContext.Provider value={{ isDataLoaded, setIsDataLoaded }}>
			{children}
		</ReportContext.Provider>
	);
}

export function useReport() {
	return useContext(ReportContext);
}